import { Row, Col } from 'react-bootstrap';
import { Column } from 'primereact/column'
import { useState, useEffect } from 'react';
import Card from '../../ui/Card';
import AddAdtrProceeds from './addAdtrProceeds';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Spinner from 'react-bootstrap/Spinner';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';
import SecurityContainer from '../securityContainer';

const ADTRProceedAdd = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [cdiacNumbers, setCdiacNumbers] = useState([]);
  const [finalSaleId, setFinalSaleId] = useState("");
  const [adtrs, setAdtrs] = useState([]);
  const [addProceedError, setAddProceedError] = useState("");
  const [adtrProceeds, setAdtrProceeds] = useState([]);
  const [openAddProceedModal, setOpenAddProceedModal] = useState(false);


  const handleCdiacChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    setFinalSaleId(checkValue);
    if (checkValue) {
      getAdtrsByFinalSaleId(checkValue);
      getProceedsByFinalSaleId(checkValue);
    }
  }


  const handleAddProceedBtn = (e) => {
    if (finalSaleId === '') {
      setAddProceedError('Please select cdiac number');
      return;
    }
    if (adtrs.length <= 0) {
      setAddProceedError('Selected Report of Final Sale does not have any ADTRs');
      return;
    }

    setAddProceedError('');
    setOpenAddProceedModal(true);
  }


  const handleModalClose = () => {
    setOpenAddProceedModal(false);
    getProceedsByFinalSaleId(finalSaleId);
  }


  useEffect(() => {
    getCdiacNumbers();
  }, []);


  const getCdiacNumbers = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getCdiacFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "updateType": "FinalSale"
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setCdiacNumbers(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }

  const getAdtrsByFinalSaleId = (selectedFinalSaleId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAdtrByFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "finalSaleId": selectedFinalSaleId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setAdtrs(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }

  const getProceedsByFinalSaleId = (selectedFinalSaleId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getProceedsByFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "finalSaleId": selectedFinalSaleId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setAdtrProceeds(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }

  const columnsAdtr = [{
    dataField: 'fiscalYrEndDate',
    text: 'Fiscal Year End Date',
    formatter: (row) => CommonService.dateFormatter(row.fiscalYrEndDate)
  }, {
    dataField: 'rptPeriodBeginBalAmt',
    text: 'Reporting Period Begin Balance Amount',
    formatter: (row) => CommonService.currencyFormatter(row.rptPeriodBeginBalAmt)
  }, {
    dataField: 'filingDate',
    text: 'Filing Date',
    formatter: (row) => CommonService.dateFormatter(row.filingDate)
  }, {
    dataField: 'statusFlag',
    text: 'Status Flag'
  }
  ];

  const columnsProceed = [{
    dataField: 'fundCategoryText',
    sort: true,
    text: 'Fund Category'
  }, {
    dataField: 'proceedAvlAmt',
    text: 'Proceeds Available Amount',
    sort: true,
    formatter: (row) => CommonService.currencyFormatter(row.proceedAvlAmt)
  }
  ];


  return (
    <SecurityContainer>
    <form onSubmit={(e) => e.preventDefault()}>
      <Card>
        <div className="panel panel-default">
          <div className="panel-heading">
            <div className="container">
              <div id="packet_id" className="panel-title">
                <h1 className="menu-title">ADTR Fund Addition</h1>
              </div>
            </div>
          </div>
          <div className="panel-body">
            <div className="container">
              <div className="form">
                {isLoading && <Spinner animation="border" variant="primary" />}
                <Row>
                  <Col md={12}>
                    <div className="control">
                      <label>CDIAC Number: </label>
                      <Typeahead
                        placeholder="Choose CDIAC Number"
                        id="finalsale"
                        labelKey="cdiacNumber"
                        onChange={e => handleCdiacChange(e, "finalSaleId")}
                        inputProps={{ 'data-validations': 'required', name: 'cdiacNumber' }}
                        options={cdiacNumbers}
                        sort
                      />
                    </div>

                  </Col>
                </Row>

                <div style={{ overflow: 'auto' }}>
                  <div className="fleft w-100">
                    <div>
                      <a href="/admin" className="dk-blue-color link-button" style={{ float: 'left' }}>Back to Admin</a>
                    </div>
                    <div style={{ float: 'right' }}>
                      <div>
                        <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddProceedBtn} >
                          Add New Fund
                        </button>
                      </div>
                    </div>
                  </div>
                  <div style={{ float: 'right' }}>
                    <p className="error"> {addProceedError}</p>
                  </div>
                </div>
                <hr />
                <div>
                  <DataGrid
                    title="ADTRs:"
                    dataSource={adtrs}
                    sortField='adtrId'
                    showQuickSearch={false}
                    emptyDataMessage='No data available to display'
                  >
                    {columnsAdtr.map((column, i) => {
                      return (
                        <Column
                          key={i}
                          field={column.dataField}
                          header={column.text}
                          body={column.formatter}
                          hidden={column.hidden}
                        />)
                    })
                    }
                  </DataGrid>
                </div>
                <hr />
                <div>
                  <DataGrid
                    title="ADTR Funds:"
                    dataSource={adtrProceeds}
                    sortField='fundCategoryText'
                    showQuickSearch={false}
                    emptyDataMessage='No data available to display'
                  >
                    {columnsProceed.map((column, i) => {
                      return (
                        <Column
                          key={i}
                          field={column.dataField}
                          header={column.text}
                          sortable={column.sort}
                          body={column.formatter}
                          hidden={column.hidden}
                        />)
                    })
                    }
                  </DataGrid>
                </div>
              </div>
            </div>
          </div>
        </div>
        {openAddProceedModal && <AddAdtrProceeds adtrs={adtrs} onModalClose={() => handleModalClose()} />}
      </Card>
    </form>
    </SecurityContainer>

  )
}

export default ADTRProceedAdd
